import { render } from "./Main.vue?vue&type=template&id=2c30ab58&scoped=true&bindings={\"trans\":\"options\",\"store\":\"setup\"}"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2c30ab58"

export default script